module.exports = __webpack_public_path__ + "static/media/Washington-DC-skyline.534640fd.jpg";